import React, { lazy, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import FormInput from '../ReactHookFormCustom/FormInput';

const Modal = lazy(() => import('reactstrap/lib/Modal'));

const RenameKanBanColumnModal = ({
  isRenameKanbanModalOpen,
  toggleIsRenameKanbanModalOpen,
  selectedColumn,
  updateTitle,
}) => {
  const { t } = useTranslation();

  const initialValues = {
    kanbanColumnName: selectedColumn?.title,
  };

  const { control, handleSubmit, reset } = useForm({
    defaultValues: initialValues,
  });

  useEffect(() => {
    reset({ kanbanColumnName: selectedColumn?.title });
  }, [selectedColumn]);

  const handleValidSubmit = (data) => {
    updateTitle(selectedColumn.id, data.kanbanColumnName);
    reset();
    toggleIsRenameKanbanModalOpen();
  };

  const toggleModalLocal = () => {
    toggleIsRenameKanbanModalOpen();
    reset();
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(handleValidSubmit)();
    }
  };

  return (
    <Modal isOpen={isRenameKanbanModalOpen} centered>
      <ModalHeader>
        <h3 className="d-flex align-items-center">
          <i className="fa fas icon-pencil mr-2"></i>
          {t('kanban.RENAME_COLUMN')}
        </h3>
      </ModalHeader>
      <form onSubmit={handleSubmit(handleValidSubmit)}>
        <ModalBody>
          <FormInput
            control={control}
            name="kanbanColumnName"
            id="kanbanColumnId"
            label={t('kanban.NEW_COLUMN_NAME')}
            onKeyDown={handleKeyDown}
            rules={{ required: t('common.REQUIRED') }}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type="submit">
            {t('common.SAVE')}
          </Button>

          <Button color="secondary" onClick={() => toggleModalLocal()}>
            {t('common.CANCEL')}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default RenameKanBanColumnModal;
